import { Button, Form, Input, InputNumber, Space } from 'antd';
import React from 'react';
import CrmModal from '../../../components/CrmModal';
import { ArrowRightOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import _ from 'lodash';
import { useMutation } from '@apollo/client';
import { UPDATE_CLIENT } from '../../../graphql/client';
import { UPDATE_PARENT } from '../../../graphql/parent';

export default function ModalAddIndicator({ isOpen, onClose, onUpdate, client, type }) {

    const [updateMutation, { loading }] = useMutation(type === 'child' ? UPDATE_CLIENT : UPDATE_PARENT);
    const [form] = Form.useForm();

    const onFinish = async (data) => {

        const indicators = _.map(client.attributes?.indicator, (item) => ({id: item.id}));

        indicators.push({
            name: data.name,
            startValue: data.startValue,
            goal: data.goal,
            result: {
                date: moment().format('YYYY-MM-DD'),
                value: data.startValue,
            },
        });

        await updateMutation({
            variables: {
                id: client.id,
                data: {
                    indicator: indicators,
                }
            },
            onCompleted: () => {
                form.resetFields();
                onUpdate();
                onClose();
            }
        })
    };

    return (
        <CrmModal isOpen={isOpen} onClose={onClose} title={'Добавить цель'}>
            <div className={'modal-basic-form'}>
                <Form size={'large'} layout={'vertical'} onFinish={onFinish} disabled={loading}>
                    <Form.Item
                        name={'name'}
                        label={'Название показателя'}
                        rules={[{ required: true, message: 'Заполните, пожалуйста' }]}
                    >
                        <Input placeholder={'Прыжки в длину, см'} />
                    </Form.Item>
                    <Space>
                        <Form.Item
                            name={'startValue'}
                            label={'Текущее значние'}
                            rules={[
                                { required: true, message: 'Заполните, пожалуйста' },
                                { type: 'number', min: 0.01, message: 'Должно быть больше 0' },
                            ]}
                        >
                            <InputNumber placeholder={'60'} />
                        </Form.Item>
                        <Form.Item>
                            <ArrowRightOutlined />
                        </Form.Item>
                        <Form.Item
                            name={'goal'}
                            label={'Цель'}
                            rules={[
                                { required: true, message: 'Заполните, пожалуйста' },
                                { type: 'number', min: 0.01, message: 'Должно быть больше 0' },
                            ]}
                        >
                            <InputNumber placeholder={'90'} />
                        </Form.Item>
                    </Space>
                    <Form.Item>
                        <Button loading={loading} htmlType={'submit'} type={'primary'} icon={<PlusOutlined />}>
                            Добавить
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </CrmModal>
    );
}
